module.exports = __webpack_public_path__ + "static/img/4.291fef7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/eng/4.png
// module id = d61N
// module chunks = 0